import OnlyHeader from "components/Headers/OnlyHeader";
import React from "react";
import { Card } from "reactstrap";

const Advertisement = () => {
  return (
    <>
      <OnlyHeader />
      <div className="w-100 h-100 d-flex flex-column justify-content-center align-items-center">
        <Card>
          <h2 className="text-center text-muted p-5">COMING SOON</h2>
        </Card>
      </div>
    </>
  );
};

export default Advertisement;
